import { render, staticRenderFns } from "./MDNewsItem.vue?vue&type=template&id=1d6ab30a&scoped=true&"
import script from "./MDNewsItem.vue?vue&type=script&lang=js&"
export * from "./MDNewsItem.vue?vue&type=script&lang=js&"
import style0 from "./MDNewsItem.vue?vue&type=style&index=0&id=1d6ab30a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6ab30a",
  null
  
)

export default component.exports